module.exports = __webpack_public_path__ + "img/icone-titulo-smartphone.339431dd.svg";